import React from 'react';
import IconWithText from 'components/Widgets/IconWithText';

export default function Duration() {
  return (
    <IconWithText
      iconClassName="clock-icon-light bg-gray-800"
      iconBg="bg-gray-100"
      wrapperClassName="mb-4"
    >
      <>
        <div className="small text-gray-800">
          Duration
        </div>

        <div className="fw-semibold text-gray-900">
          50 minutes
        </div>
      </>
    </IconWithText>
  );
}
